import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { obtenerLibroPorId } from '../../services/LibrosService';
import { comprobarElegibilidad,solicitarPrestamo,verificarPrestamo } from '../../services/PrestamosService';
import { enviarCalificacion, verificarCalificacion, obtenerCalificacionDeUsuario } from '../../services/CalificacionService';
import Barra from '../../components/barrasuperior/index';
import { MdFavoriteBorder, MdFavorite, MdContentCopy, MdCheck} from 'react-icons/md'
import BooksSlider from '../../components/booksSlider';
import { acortarTexto, jwtDecoder, renderStarRating, useGetWindowDimensions } from '../../utils/functions';
import Skeleton from "react-loading-skeleton";
import { useUser } from '../../context/userContext';
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import './index.css';
import BookImage from '../../components/bookImage';
import Loader from '../../components/loader';
import defaultAuthorPic from '../../assets/defaultAuthor.png';



function LibroDetails() {
    const { libroid } = useParams();
    const [bookData, setBookData] = useState({});
    const { userData } = useUser(); 
    const [urlCopiada, setUrlCopiada] = useState(false); 
    const [loading, setLoading] = useState(true);
    const [yaCalificado, setYaCalificado] = useState();
    const [yaPrestado, setYaPrestado] = useState();
    const [userRating, setUserRating] = useState(null); 
    const [error, setError] = useState(null);
    const windowDimensions = useGetWindowDimensions();
    const navigate = useNavigate();
    const location = useLocation();


     // Función auxiliar para mostrar modal de alerta si no hay usuario
    const showLoginAlert = async () => {
      const result = await Swal.fire({
        title: 'Inicia Sesión',
        text: 'Para calificar o prestar este libro, debes iniciar sesión.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Inicia Sesión',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#21807C',
        cancelButtonColor: '#d33',
        customClass: {
          title: 'custom-title'
        }
      });
      if (result.isConfirmed) {
        navigate('/signin', { state: {location}});
      }
    };

    const getData = async () => {
      if (libroid) {
        setLoading(true);
        setError(null); // Resetea el estado de error antes de intentar obtener los datos
        try {
          const idLibro = parseInt(libroid, 10);
          if (isNaN(idLibro)) {
            throw new Error("El ID del libro no es válido.");
          }
          const response = await obtenerLibroPorId(parseInt(libroid));
          setBookData(response);

          // Ejecutar verificaciones solo si hay usuario
          if (userData) {
            // Verificar si el usuario ya calificó o si ya tiene el libro prestado
            const response2 = await verificarCalificacion(userData.cif, libroid);
            setYaCalificado(response2);
            const responseYaPrestado = await verificarPrestamo(userData.cif, libroid);
            setYaPrestado(responseYaPrestado);
            const userRating = await obtenerCalificacionDeUsuario(userData.cif, libroid);
            setUserRating(userRating);
          }
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      }
    };
    
    


    useEffect(() => {      
      getData();
    },[libroid]);

    const handleCalificarClick = async () => {
      // Si no hay usuario, se muestra el modal para iniciar sesión.
      if (!userData) {
        await showLoginAlert();
        return;
      }
      // Si hay usuario, continuar con la lógica de calificación
      const { value: puntuacion } = await Swal.fire({
        title: 'Califica este libro',
        icon: 'question',
        input: 'range',
        inputLabel: 'Tu puntuación',
        inputAttributes: {
          min: 0,
          max: 5,
          step: 0.5
        },
        inputValue: 2.5,
        confirmButtonColor: '#21807C',
        customClass: {
          title: 'custom-title'
      }
      });
    
      if (puntuacion != null) {
        try {
          await enviarCalificacion(userData.cif, bookData.idLibro, puntuacion); // Asegúrate de reemplazar 'TuCIF' con el CIF del estudiante
          Swal.fire({
            title: '¡Calificación enviada!',
            text: 'Gracias por tu opinión.',
            icon: 'success',
            confirmButtonColor: '#21807C',
            customClass: {
              title: 'custom-title'
          }

          });
          getData();
        } catch (error) {
          Swal.fire({
            title: 'Error',
            text: 'No se pudo enviar tu calificación.',
            icon: 'error'
          });
        }
      }
    };

    const handlePrestarClick = async () => {
      // Si no hay usuario, se muestra el modal para iniciar sesión.
      if (!userData) {
        await showLoginAlert();
        return;
      }
      try {
        const resultadoElegibilidad = await comprobarElegibilidad(userData.cif, bookData.idLibro);
    
        if (resultadoElegibilidad.mensaje === "Préstamo Pre-Aprobado") {
          const fechaLimiteDevolucion = resultadoElegibilidad.fechaLimiteDevolucion;
    
          // Variables para almacenar las opciones
          let idRole;
          let idCarreraCurso;
    
          // Verificar si el usuario tiene múltiples roles
          if (userData.roles && userData.roles.length > 1) {
            // Construir opciones para Swal
            const opcionesRoles = userData.roles.map((role) => ({
              text: role.nombre,
              value: role.id.toString(),
            }));
    
            const { value: selectedRole } = await Swal.fire({
              title: '¿Para cual de tus roles necesitas este libro?',
              input: 'select',
              inputOptions: opcionesRoles.reduce((obj, item) => ({ ...obj, [item.value]: item.text }), {}),
              inputPlaceholder: 'Selecciona un rol',
              showCancelButton: true,
              confirmButtonColor: '#28A745',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Siguiente',
              cancelButtonText: 'Cancelar',
              customClass: {
                title: 'custom-title'
              }
            });
    
            if (selectedRole) {
              idRole = parseInt(selectedRole);
            } else {
              // El usuario canceló
              return;
            }
          } else if (userData.roles && userData.roles.length === 1) {
            idRole = userData.roles[0].id;
          } else {
            // Manejar caso donde no hay roles
            Swal.fire({
              title: 'Error',
              text: 'No se encontraron roles asociados a tu usuario.',
              icon: 'error',
              confirmButtonColor: '#21807C',
            });
            return;
          }
    
          // Verificar si el usuario tiene múltiples carreras
          if (userData.carrerasCursos && userData.carrerasCursos.length > 1) {
            // Construir opciones para Swal
            const opcionesCarreras = userData.carrerasCursos.map((carrera) => ({
              text: carrera.nombre,
              value: carrera.id.toString(),
            }));
    
            const { value: selectedCarrera } = await Swal.fire({
              title: '¿Para cual de tus carreras/cursos necesitas este libro?',
              input: 'select',
              inputOptions: opcionesCarreras.reduce((obj, item) => ({ ...obj, [item.value]: item.text }), {}),
              inputPlaceholder: 'Selecciona una carrera o curso',
              showCancelButton: true,
              confirmButtonColor: '#28A745',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Siguiente',
              cancelButtonText: 'Cancelar',
              customClass: {
                title: 'custom-title'
              }
            });
    
            if (selectedCarrera) {
              idCarreraCurso = parseInt(selectedCarrera);
            } else {
              // El usuario canceló
              return;
            }
          } else if (userData.carrerasCursos && userData.carrerasCursos.length === 1) {
            idCarreraCurso = userData.carrerasCursos[0].id;
          } else {
            // Manejar caso donde no hay carreras
            Swal.fire({
              title: 'Error',
              text: 'No se encontraron carreras o cursos asociados a tu usuario.',
              icon: 'error',
              confirmButtonColor: '#21807C',
            });
            return;
          }
    
          // Mostrar confirmación final con detalles
          const result = await Swal.fire({
            title: 'Confirmación de Préstamo',
            html: `
              <div>
                <strong>Libro a prestar:</strong> ${bookData.titulo}
                <br>
                <strong>Fecha límite de devolución:</strong> ${fechaLimiteDevolucion}
                <br>
                <strong>Rol:</strong> ${userData.roles.find(role => role.id === idRole).nombre}
                <br>
                <strong>Carrera/Curso:</strong> ${userData.carrerasCursos.find(carrera => carrera.id === idCarreraCurso).nombre}
              </div>
              <div style="margin-top: 40px;">
                <strong style="color: red;">Una vez solicitado, no se puede cancelar el préstamo.</strong>
              </div>
              <div style="margin-top: 22px;">
                <strong>¿Está seguro de querer proceder?</strong>
              </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28A745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, prestar libro',
            cancelButtonText: 'No, cancelar',
            customClass: {
              title: 'custom-title'
            }
          });
    
          if (result.isConfirmed) {
            // Llamar al servicio para realizar el préstamo
            try {
              const prestamoResult = await solicitarPrestamo(userData.cif, bookData.idLibro, idRole, idCarreraCurso);
              // Procesar el resultado del préstamo
              Swal.fire({
                title: 'Préstamo realizado con éxito',
                html: `
                  <div style="margin-top: 20px;">
                    Tu código de retiro es:
                    <br>
                    <strong style="color: green; margin-top: 10px;">${prestamoResult.codigoRetiro}</strong>
                  </div>
                `,
                icon: 'success',
                confirmButtonColor: '#21807C',
                customClass: {
                  title: 'custom-title'
                }
              });
              getData();
            } catch (errorPrestamo) {
              Swal.fire({
                title: 'Error',
                text: errorPrestamo.response.data,
                icon: 'error',
                confirmButtonColor: '#21807C',
              });
            }
          }
        }
      } catch (error) {
        const mensajeError = error.response && error.response.data && typeof error.response.data === 'object'
        ? error.response.data.message
        : error.response.data;

        let mensajeErrorAjustado = mensajeError;

        // Verificar si hay un punto y texto después
        const indicePunto = mensajeError.indexOf('.');
        if (indicePunto !== -1 && mensajeError.substring(indicePunto + 1).trim() !== '') {
            const mensajePrincipal = mensajeError.substring(0, indicePunto + 1);
            const nota = mensajeError.substring(indicePunto + 1).trim();
            mensajeErrorAjustado = `${mensajePrincipal}<br><br><b>Nota:</b> ${nota}`;
        }

        Swal.fire({
            title: 'Solicitud Denegada',
            html: mensajeErrorAjustado,
            icon: 'error',
            confirmButtonColor: '#21807C',
        });

      }
    };
    

      // Función para copiar la URL actual al portapapeles
    const copiarURL = async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setUrlCopiada(true); // Actualiza el estado para indicar que la URL ha sido copiada
        setTimeout(() => setUrlCopiada(false), 2000); // Opcional: reiniciar el estado después de 2 segundos
      } catch (err) {
        console.error("Error al copiar la URL", err);
      }
    }

    const GetTitleTextLimit = (winWidth) => {
      switch (true) {
          case winWidth > 1800:
              return 32;
          case winWidth > 920:
              return 30;
          case winWidth > 840:
              return 26;
          case winWidth > 800:
              return 22;
          case winWidth > 768:
              return 22;
          default:
              return 50; // Define un valor por defecto o deja esta parte según tu lógica.
      }
    };

    const GetStarsRatingSize = (winWidth) => {
      switch (true) {
          case winWidth > 900:
              return 18;
          case winWidth <= 900:
              return 15;
          default:
              return 13.5; // Define un valor por defecto o deja esta parte según tu lógica.
      }
    };



  if(loading){
    <div style={{ display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <Loader label={'Cargando...'} />
    </div>
  }else if(error){
    return (
      <div>
        {userData && <Barra />}
        <div className='error-message'>
          <h2>Error</h2>
          <p>{error}</p>
          <Link className='error-messageBtn' to='/menuestudiante'>Volver al inicio</Link>
        </div>
      </div>
    );
  } else {
    return (
      <div>
          {userData && <Barra />}
          <div className='libroDetails-container'>
            <div className='blurBand'>
              <BookImage
                  src={bookData.imagen}
                  alt={bookData.titulo}
                  className="blur-picture" 
              />
            </div>
            <div className='libroDetailsContent-wrapper'> 
            <div className='libroDetails-PicInfo'>
              <BookImage
                    src={bookData.imagen}
                    alt={bookData.titulo}
                    className="bookPicture" 
              />
              <div className='general-info'>
                    <h1 className='title'>{acortarTexto(bookData.titulo, GetTitleTextLimit(windowDimensions.winWidth))}</h1>
                    <div className='autores-container'>
                          <div className='autorInformation'>
                            <img src={bookData.autorPic || defaultAuthorPic} alt={bookData.nombreAutor} className="autorPicture" />
                            <div>
                            <h2>{bookData.nombreAutor}</h2>
                            <p>{bookData.autorNumLibros}{bookData.autorNumLibros > 1 ? ' Libros Aquí' : ' Libro Aquí'}</p>
                            </div>
                          </div>
                    </div>
                    <div className='calificacion'>
                      {renderStarRating(bookData.calificacionPromedio, 24)}
                      <p>{bookData.numCalificaciones} {bookData.numCalificaciones === 1 ? 'Calificación' : 'Calificaciones'}</p>
                    </div>
                  </div>
            </div>           

            <div className='detallesArea'>
              <div className='leftSection'>
                <div className='sinopsisContainer'>
                    <h2>Sinopsis</h2>
                    <p>
                      {bookData.sinopsis && bookData.sinopsis.trim() !== ''
                        ? acortarTexto(bookData.sinopsis, 380)
                        : 'Sinopsis no disponible'}
                    </p>
                </div>
                <div className='tematicasContainer'>
                  <h4 className='tematicas'>{bookData.nombreCategoria}</h4>
                  <h4 className='tematicas'>{bookData.publicacionDistribucion}</h4>
                </div>
                
              </div>
              <div className='rightSection'>
                <div className='btnSection'>
                  {
                    yaPrestado ? (
                      <button className='librosBtnDisabled' disabled>Prestado</button>
                    ) : (
                      <button
                        className={bookData.prestable ? 'librosBtn' : 'librosBtnDisabled'}
                        disabled={!bookData.prestable}
                        onClick={handlePrestarClick}
                      >
                        {bookData.prestable ? 'Prestar' : 'Solo en Biblioteca'}
                      </button>
                    )
                  }
                 
                  {yaCalificado ? (
                    <button className='librosBtn' disabled>
                        <div className='yacalificadoBtn' >
                            Calificado
                        </div>
                        <div>
                            {renderStarRating(userRating, GetStarsRatingSize())}
                        </div>
                    </button>
                  ) : (
                    <button className='librosBtn' onClick={handleCalificarClick}>
                        Calificar
                    </button>
                  )}
                  <button className='librosBtn' onClick={copiarURL}>
                    {urlCopiada ? <MdCheck color='#0B545B' size={28}/> : <MdContentCopy color='black' size={28} />} 
                  </button>
                </div>
                <div className='librosRelacionados'>
                  <BooksSlider idFondo={bookData.idFondo} isAcademic={bookData.nombreCategoria === 'Académico' ? 1 : 2} tipo={'relacionados'}/>
                </div>
              </div>
            </div>
            </div>
          </div>
      </div>
    )
  }


  
}

export default LibroDetails;